/* OBFUSCATED CODE - INTELLECTUAL PROPERTY PROTECTED */
'use client';
import { useState, useCallback, useEffect } from 'react';
export function usePresetManager(
  presets,
  activePreset,
  scaleVal,
  radiusVal,
  densityVal,
  speedFactorVal
) {
  const [defaultPresetValues, setDefaultPresetValues] = useState({});
  const [hasPresetChanges, setHasPresetChanges] = useState(false);
  const registerDefaultValues = useCallback((
    presetKey,
    scale,
    radius,
    density,
    speedFactor
  ) => {
    setDefaultPresetValues(prev => ({
      ...prev,
      [presetKey]: {
        scale,
        radius,
        density,
        speedFactor
      }
    }));
  }, []);
  const getDefaultValues = useCallback(() => {
    return defaultPresetValues[activePreset] || null;
  }, [activePreset, defaultPresetValues]);
  const checkForChanges = useCallback(() => {
    const defaults = defaultPresetValues[activePreset];
    if (!defaults) {
      setHasPresetChanges(false);
      return false;
    }
    const hasChanges =
      scaleVal !== defaults.scale ||
      radiusVal !== defaults.radius ||
      densityVal !== defaults.density ||
      speedFactorVal !== defaults.speedFactor;
    setHasPresetChanges(hasChanges);
    return hasChanges;
  }, [
    activePreset,
    defaultPresetValues,
    scaleVal,
    radiusVal,
    densityVal,
    speedFactorVal
  ]);
  useEffect(() => {
    checkForChanges();
  }, [scaleVal, radiusVal, densityVal, speedFactorVal, activePreset, checkForChanges]);
  const getNextPreset = useCallback((currentPreset) => {
    const order = ['Big', 'Mid', 'Small'];
    const idx = order.indexOf(currentPreset);
    return order[(idx + 1) % order.length];
  }, []);
  return {
    hasPresetChanges,
    defaultPresetValues,
    registerDefaultValues,
    getDefaultValues,
    checkForChanges,
    getNextPreset,
    clearChangesFlag: () => setHasPresetChanges(false)
  };
}
